import { openMenuAndGet } from '../shared/domHelpers'
import demoSession from '../demo/DemoSession'
import { ensureDemoUiStyles } from '../demo/DemoExitButton'

const getListaEquipamentos = () => openMenuAndGet('equipamento', 'group-equipamento', '[data-tour="menu-lista-equipamentos"]')
const getPerfisCliente = () => openMenuAndGet('cliente', 'group-cliente', '[data-tour="menu-perfis-cliente"]')
const getListaClientes = () => openMenuAndGet('cliente', 'group-cliente', '[data-tour="menu-lista-clientes"]')
const getMonitorados = () => openMenuAndGet('equipamento', 'group-equipamento', '[data-tour="menu-monitorados"]')

const bindChoiceButtons = (tourManager) => {
    ensureDemoUiStyles()

    setTimeout(() => {
        const startDemo = document.querySelector('[data-hdv-choice-demo]')
        const startGuide = document.querySelector('[data-hdv-choice-guide]')

        if (startDemo && !startDemo._hdvBound) {
            startDemo._hdvBound = true
            startDemo.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                tourManager.finish('introdutorio')
                demoSession.start({ startTour: 'demo-equipamento' })
            })
        }

        if (startGuide && !startGuide._hdvBound) {
            startGuide._hdvBound = true
            startGuide.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                tourManager.moveNext()
            })
        }
    }, 0)
}

const buildIntrodutorioTourSteps = (tourManager) => [
    {
        onHighlighted: () => bindChoiceButtons(tourManager),
        popover: {
            title: 'Como deseja começar?',
            description:
                '<br><strong>Modo demonstração</strong><br>' +
                'Experimente a plataforma com dados de exemplo e acompanhe todo o processo, do cadastro aos gráficos e supervisórios.<br><br>' +
                '<strong>Guia rápido</strong><br>' +
                'Faça um tour pelos principais recursos. Os detalhes podem ser acessados depois pelo ícone de ajuda de cada tela.<br><br>' +
                '<div class="hdv-tour-choice-actions">' +
                '<button type="button" class="hdv-tour-choice-demo" data-hdv-choice-demo>Iniciar modo demonstração</button>' +
                '<button type="button" class="hdv-tour-choice-guide" data-hdv-choice-guide>Iniciar guia rápido</button>' +
                '</div>',
            side: 'over',
            align: 'center',
            showButtons: ['close'],
        },
    },
    {
        popover: {
            title: 'Bem-vindo!',
            description: 'Esta é a Dashboard, a tela inicial da plataforma. Aqui você acompanha rapidamente a situação e localização dos seus monitorados.',
        },
    },
    {
        popover: {
            title: 'Cadastros básicos',
            description: 'Para começar a utilizar a plataforma, você realizará os cadastros básicos de <strong>Equipamento</strong>, <strong>Cliente</strong> e, por fim, do <strong>Monitorado</strong>. Clique em <strong>Próximo</strong> para conhecer esse mapa.',
        },
    },
    {
        element: getListaEquipamentos,
        popover: {
            title: 'Lista de Equipamentos',
            description: 'Aqui você cadastra os dispositivos que enviarão informações para a plataforma. Este é o primeiro passo para criar um Monitorado.',
            side: 'right',
            align: 'start',
        },
        onHighlighted: (element) => {
            const onListaClick = () => {
                tourManager.handoff('introdutorio', 'novo-equipamento', '[data-tour="help-equipamento-grid"]')
            }

            element.addEventListener('click', onListaClick)
            element._hdvTourListaClick = onListaClick
        },
        onDeselected: (element) => {
            if (element?._hdvTourListaClick) {
                element.removeEventListener('click', element._hdvTourListaClick)
                delete element._hdvTourListaClick
            }
        },
    },
    {
        element: getPerfisCliente,
        popover: {
            title: 'Perfis de Cliente',
            description: 'Antes de cadastrar um cliente, crie um perfil com as permissões e configurações que serão utilizadas por ele.',
            side: 'right',
            align: 'start',
        },
    },
    {
        element: getListaClientes,
        popover: {
            title: 'Lista de Clientes',
            description: 'Aqui você cadastra os clientes da plataforma, criando o login de acesso ao Portal Web e ao aplicativo. Esse cadastro é necessário para criar o seu primeiro Monitorado.',
            side: 'right',
            align: 'start',
        },
    },
    {
        element: getMonitorados,
        popover: {
            title: 'Monitorados',
            description: 'O Monitorado é o cadastro final da plataforma e depende de um Equipamento e um Cliente já cadastrados. Use o ícone de ajuda de cada tela para um guia detalhado.',
            side: 'right',
            align: 'start',
        },
    },
]

export default buildIntrodutorioTourSteps
